import { Outlet } from "react-router-dom";
const VisitLogs = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default VisitLogs;
